export enum ClientTypes {
    GET_MEASUREMENTS_LOADING = "GET_MEASUREMENTS_LOADING",
    GET_MEASUREMENTS_SUCCESS = "GET_MEASUREMENTS_SUCCESS",
    GET_MEASUREMENTS_FAILURE = "GET_MEASUREMENTS_FAILURE"
}
